var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleChange}}),_c('div',[_c('input',{attrs:{"type":"button","value":"关闭窗口"},on:{"click":_vm.handleClose}})]),_c('div',[_c('input',{attrs:{"type":"button","value":"发送数据"},on:{"click":_vm.handleReplace}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }